module.exports = __webpack_public_path__ + "img/one.ddefa79d.jpg";